import React from "react";
import AddStoreComponent from "../components/AddStoreComponent";
import CreateStore from "components/features/store/create/Index"

const AddStore = () => {
  return <CreateStore />;
};
export default AddStore;
